import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCGT6g9X71NXsvYzEpdnvDGJEkjP1xp6dw",
  authDomain: "hoast-26d3e.firebaseapp.com",
  projectId: "hoast-26d3e",
  storageBucket: "hoast-26d3e.firebasestorage.app",
  messagingSenderId: "41767365480",
  appId: "1:41767365480:web:a281fba81065996adc84dd",
  measurementId: "G-XECMDFWJDB"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleprovider = new GoogleAuthProvider();
googleprovider.setCustomParameters({
  prompt: 'select_account'
});

let messaging;
if ("Notification" in window && navigator.serviceWorker) {
  messaging = getMessaging(app);
} else {
  console.warn("Push notifications not supported on this browser.");
}

export { auth, googleprovider, messaging };